import React from 'react'

import { BASE_URL, ICONS } from '../../../constants'
import List from '../../components/List'

import { ROUTE_NAME, API_URL } from '../constants'

const OverlayList = () => {
  const columns = [
    { header: 'Id', value: (item) => item.id },
    {
      header: 'Icon',
      value: (item) => (
        <img alt={item.name} src={`${BASE_URL}${ICONS.AI.DIR}${item.icon}`} />
      ),
    },
    { header: 'Name', value: (item) => item.name, isLink: true },
  ]
  return (
    <List
      title="Overlays"
      routeName={ROUTE_NAME}
      apiUrl={API_URL}
      columns={columns}
    />
  )
}

export default OverlayList
